module.exports = __webpack_public_path__ + "static/media/aikBankLogo.197c1fe2.png";